import {
  fetchOverviewSummary,
  fetchFinancialOverview,
  fetchOnlineRechargeSummary,
  fetchGCOverview,
} from "../../services/overviewService";
import {
  overviewSummaryFetched,
  financialOverviewFetched,
  onlineRechargeSummaryFetched,
  gcOverviewFetched,
} from "../actions/overviewAction";
import { hideLoading, showLoading } from "../../shared/widgets/bar-loader/src";
import { fetchDataSyncStatus } from "../../services/citiesService";
import { updateRefreshUpliftStatus } from "../actions/contractedVehicleAction";
import { defaultErrorFn, defaultResponseFn } from "./actionCreatorUtil";

const apiActions = [
  {
    service: fetchOverviewSummary,
    responseFn: async (response, params) => {
      const { dispatch } = params;
      dispatch(overviewSummaryFetched(response));
      const dataSyncStatusResponse = await fetchDataSyncStatus();
      dispatch(
        updateRefreshUpliftStatus(
          dataSyncStatusResponse?.success ? dataSyncStatusResponse.success : "",
        ),
      );
    },
  },
  {
    service: fetchFinancialOverview,
    action: financialOverviewFetched,
  },
  {
    service: fetchOnlineRechargeSummary,
    action: onlineRechargeSummaryFetched,
  },
  {
    service: fetchGCOverview,
    action: gcOverviewFetched,
  },
];

export const fetchAllOverviewData = (params, loaderType = "header") => async (dispatch) => {
  dispatch(showLoading(loaderType));

  const apiResults = await
  Promise.allSettled(apiActions.map((apiAction) => apiAction.service(params)));

  apiResults.forEach((apiResult, index) => {
    const handlerParams = { ...params, dispatch, ...apiActions[index] };
    if (apiResult.status === "fulfilled") {
      const responseFn = apiActions[index].responseFn || defaultResponseFn;
      responseFn(apiResult.value, handlerParams);
    } else {
      const errorFn = apiActions[index].errorFn || defaultErrorFn;
      errorFn(apiResult.reason, handlerParams);
    }
  });

  dispatch(hideLoading(loaderType));
};
